import { createContext, useContext } from 'react'
import type { ActionSnapshot } from './types'

/**
 * A batch waiting for the trader's OK (2026-10-15, one-assistant Phase 2c):
 * one line per call that asks first, and the two answers.
 */
export interface ActionProposal {
  id: string
  lines: string[]
  apply: () => void
  cancel: () => void
}

export interface CompanionActionContextValue {
  pendingAction: ActionSnapshot | null
  setPendingAction: (snapshot: ActionSnapshot | null) => void
  pendingProposal: ActionProposal | null
  setPendingProposal: (proposal: ActionProposal | null) => void
  approveAction: (() => void) | null
  revertAction: (() => void) | null
  setActionHandlers: (approve: () => void, revert: () => void) => void
  clearActionHandlers: () => void
}

export const CompanionActionContext = createContext<CompanionActionContextValue | null>(null)

export function useCompanionActionContext(): CompanionActionContextValue {
  const ctx = useContext(CompanionActionContext)
  if (!ctx) throw new Error('useCompanionActionContext must be used within CompanionActionProvider')
  return ctx
}
